import { inject, Injectable } from '@angular/core';
import { FormFieldModel, FormModel } from '@alfresco/adf-core';
import { BaseProcessor } from '../../base.processor';
import { GenerischeFreigabeVariables } from '../generische-freigabe.variables';
import { BpmService } from '@alf-nx-workspace/shared/utils';
import { EbenEmailSelectorValidator } from '../../validators/email-selector.validator';

@Injectable({ providedIn: 'root' })
export class GenerischeFreigabeStartformProcessor extends BaseProcessor {

  static FORM_NAME = 'generische-freigabe';
  public readonly FORM_NAME = GenerischeFreigabeStartformProcessor.FORM_NAME;

  readonly bpmService = inject(BpmService);

  constructor() {
    super();
  }

  onLoaded(form: FormModel) {
    super.onLoaded(form);
  }

  onValidated(form: FormModel): void {
    super.onValidated(form);
  }

  onFieldValueChange(field: FormFieldModel): void {
    if (field.id === GenerischeFreigabeVariables.recipients) {
      if (!field.value) {
        field.params[EbenEmailSelectorValidator.invalidEmails] = [];
        return;
      }
      this.bpmService.validateEmails(field.value)
        .subscribe((invalidEmails: string[]) => {
          field.params[EbenEmailSelectorValidator.invalidEmails] = invalidEmails;
          (<FormModel>field.form).validateField(field);
        });
    }
  }


}
